import { render, staticRenderFns } from "./OgUserSelect.vue?vue&type=template&id=3066ee28&scoped=true&"
import script from "./OgUserSelect.vue?vue&type=script&lang=js&"
export * from "./OgUserSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3066ee28",
  null
  
)

export default component.exports